// src/components/TBAdminLogout.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import { useSnackbar } from "notistack";

const TBAdminLogout = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await signOut(auth); 
        enqueueSnackbar("Successfully logged out", { variant: "success" });
        navigate("/tbadmin");
      } catch (error) {
        enqueueSnackbar("Error logging out. Please try again.", { variant: "error" });
      }
    };

    handleLogout();
  }, [navigate, enqueueSnackbar]);

  return <div>Logging out...</div>;
};

export default TBAdminLogout;
